import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AngularFireFunctions} from '@angular/fire/compat/functions';
import {lastValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalableMemberService {

  constructor (
    private _httpClient: HttpClient,
    private ff: AngularFireFunctions) { }

  async getMemberById (member_uid) {
    const getMemberById = this.ff.httpsCallable('getMemberById');
    return getMemberById({'member_uid': member_uid})
  }

  async updateMemberById (data: any) {
    const updateMemberById = this.ff.httpsCallable('updateMemberById');
    return updateMemberById(data)
  }

  async updateInviteById (data: any) {
    const updateInviteById = this.ff.httpsCallable('updateInviteById');
    return updateInviteById(data)
  }

  async requestReceipt (order_id) {
    const param = {'id': order_id}
    const requestReceipt = this.ff.httpsCallable('requestReceipt');
    return lastValueFrom(requestReceipt(param));
  }
    
    async requestReceipt_2026 (order_id) {
    const param = {'id': order_id}
    const requestReceipt = this.ff.httpsCallable('requestReceipt_2026');
    return lastValueFrom(requestReceipt(param));
  }

}
